(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sml-s-pdp"] && !Shopify.designMode) return;
  try {
    function syncS19BundleImage(root, reveal) {
 const selected=root.querySelector('[data-s19-image]:checked');
 if(!selected)return;
 const hero=root.querySelector('[data-s5-slide="1"] img');
 const thumb=root.querySelector('[data-s5-thumb="1"] img');
 [hero,thumb].filter(Boolean).forEach(img=>{
  img.removeAttribute('srcset');
  img.src=selected.dataset.s19Image;
  img.alt=selected.closest('label').querySelector('.s5-option-title')?.textContent.trim()||'Moruga Starter Kit';
 });
 if(reveal)root.querySelector('[data-s5-thumb="1"]')?.click();
}
document.addEventListener('change',event=>{
 if(event.target.matches('[data-s19-image]'))syncS19BundleImage(event.target.closest('[data-s5-pdp]'),true);
});
function initS19BundleImages(){document.querySelectorAll('[data-s5-pdp]').forEach(root=>syncS19BundleImage(root,false));}
document.addEventListener('DOMContentLoaded',initS19BundleImages);
window.addEventListener('pageshow',initS19BundleImages);
document.addEventListener('shopify:section:load',initS19BundleImages);
initS19BundleImages();

document.addEventListener('click',event=>{
 const button=event.target.closest('[data-s5-thumb]');if(!button)return;
 const root=button.closest('[data-s5-pdp]');
 root.querySelectorAll('[data-s5-thumb]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
 root.querySelectorAll('[data-s5-slide]').forEach(item=>{item.hidden=item.dataset.s5Slide!==button.dataset.s5Thumb;if(item.hidden)item.querySelectorAll('video').forEach(video=>video.pause());});
});
document.addEventListener('change',event=>{
 const input=event.target.closest('[data-s12-ref]');if(!input)return;
 const root=input.closest('[data-s5-pdp]'),summary=root.querySelector('[data-s12-summary]');
 const form=input.closest('[data-moruga-cart-form]');
 if(form){const button=form.querySelector('[data-moruga-add]');button.disabled=input.dataset.available!=='true'||form.dataset.pending==='true';button.querySelector('[data-moruga-add-label]').textContent=input.dataset.available==='true'?form.dataset.addLabel:form.dataset.unavailableLabel;form.querySelector('[data-moruga-cart-error]').hidden=true;root.querySelector('[data-sml-price]').textContent=input.dataset.priceLabel;}
 const reference=Number(input.dataset.s12Ref),saving=reference-Number(input.dataset.s12Total);
 const money=n=>new Intl.NumberFormat(document.documentElement.lang||'de-DE',{style:'currency',currency:'EUR'}).format(n/100);
 summary.hidden=saving<=0;summary.querySelector('[data-s12-reference]').textContent=money(reference);summary.querySelector('[data-s12-saving]').textContent=money(Math.max(0,saving));
});
document.addEventListener('submit',async event=>{
 const form=event.target.closest('[data-moruga-cart-form]');if(!form)return;
 event.preventDefault();
 const input=form.querySelector('input[name="id"]:checked');
 if(form.dataset.pending==='true'||input?.dataset.available!=='true')return;
 const button=form.querySelector('[data-moruga-add]'),label=button.querySelector('[data-moruga-add-label]'),error=form.querySelector('[data-moruga-cart-error]');
 form.dataset.pending='true';form.setAttribute('aria-busy','true');button.disabled=true;label.textContent=form.dataset.pendingLabel;error.hidden=true;
 try{
  const response=await fetch(form.action.replace(/\/add\/?$/, '/add.js'),{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:input.value,quantity:1,properties:{_moruga_offer:form.dataset.experience}}]})});
  const result=await response.json();
  if(!response.ok||result.status>=400)throw new Error(typeof result.description==='string'?result.description:form.dataset.errorLabel);
  window.location.assign(form.dataset.cartUrl);
 }catch(err){error.textContent=err.message&&err.message!=='Failed to fetch'?err.message:form.dataset.errorLabel;error.hidden=false;}
 finally{delete form.dataset.pending;form.removeAttribute('aria-busy');button.disabled=form.querySelector('input[name="id"]:checked')?.dataset.available!=='true';label.textContent=button.disabled?form.dataset.unavailableLabel:form.dataset.addLabel;}
});
  } catch(e) { console.error(e); }
})();

})();
